import "./options.scss";

// Localize UI elements
const localizeUI = () => {
  // Set text content for elements with translations
  document.getElementById("options-title")!.textContent =
    chrome.i18n.getMessage("optionsTitle");
  document.getElementById("options-instructions")!.textContent =
    chrome.i18n.getMessage("optionsEditInstructions");
};

// Load data when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  localizeUI();
});
